import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🛋️", key: "redesignRoom" },
  { emoji: "📦", key: "declutter" },
  { emoji: "🎨", key: "newStyle" },
  { emoji: "✨", key: "doAll" },
]

export default function HomeStartHerePage() {
  return <RadioCardListPage translationKey="homeStartHere" options={OPTIONS} />
}
